import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';

@Directive({
    selector: '[uflaValidEmailList]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: ValidEmailListDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class ValidEmailListDirective {
    public readonly EMAIL_PATTERN = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{1,4}$';

  @Input() uflaValidEmailList: string;

  constructor() {
  }

  validate(nameControl: AbstractControl): Observable<ValidationErrors | null> | Observable<ValidationErrors | null> | ValidationErrors {
      {
          if (!nameControl.value) {
              return of(null);
          }

          const re = new RegExp(this.EMAIL_PATTERN);

          let invalid = false;

          const l = nameControl.value as string;
          l.split(',').forEach(email => {
              email = email.trim();

              if (!re.test(email)) {
                  invalid = true;
              }
          });

          return invalid ? of({ validEmailList: true }) : of(null);
      }
  }

}
